import React from 'react';
import { Provider } from 'react-redux';
import { Helmet } from 'react-helmet';
import { ToastContainer, Slide } from "react-toastify";
import { PersistGate } from 'redux-persist/integration/react';
import createStore from './state';
import AuthProvider from './providers/AuthProvider';
import SearchProvider from './providers/SearchProvider';
import SignalRProvider from './providers/SignalRProvider';
import LogoutWrapper from './components/containers/LogoutPage';
import "react-toastify/dist/ReactToastify.min.css";

export const { store, persistor } = createStore();

const App = ({ element }) => {
  return (
    <Provider store={store}>
       <PersistGate loading={null} persistor={persistor}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>SoftRig Developer</title>
        </Helmet>
        <SearchProvider>
          <AuthProvider>
            <LogoutWrapper>
              <SignalRProvider>
                {element}
              </SignalRProvider>
            </LogoutWrapper>
          </AuthProvider>
        </SearchProvider>
      </PersistGate>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Slide}
      /> 
    </Provider>
  );
};

export default App;
